import {Link} from "@montana/shared/link";
import {Media} from "@montana/shared/media";
import {epiMediaRatioToEnum} from "@montana/helpers/epi-mapping.helper";
import {Appear} from "@montana/shared/appear";
import React, {CSSProperties} from "react";
import {IM10BannerCardBlock, IM24CompositionCard} from "@montana/models/generated/cms.interface";
import cx from "clsx";
import {SeriesLink} from "@montana/shared/series-link/series-link.component";

type M10BannerCardComponentProps = {
    mediaDisplayRatio?: string;
    truncateDescription?: number;
};

export function M10BannerCardComponent(props: M10BannerCardComponentProps & (IM10BannerCardBlock | IM24CompositionCard)) {
    const {link, image, title, tagLink, mediaDisplayRatio, truncateDescription, id} = props;
    const {video, description} = props as IM10BannerCardBlock;

    const isCommerceCard = !tagLink && !description;
    const isSeriesCard = !tagLink;

    return (
        <div className={cx(`banner-bundle-card`, isCommerceCard && 'banner-bundle-card--commerce', isSeriesCard && 'banner-bundle-card--series')}>
            <Link to={link?.url} aria-labelledby={id}>
                <Media
                    image={image}
                    video={video}
                    mediaRatio={epiMediaRatioToEnum(mediaDisplayRatio)}
                    sizes={mediaDisplayRatio === 'portrait' ? [
                        '(min-width: 1000px) 356px',
                        '50vw'
                    ].join(', ') : [
                        '(min-width: 1000px) 486px',
                        '50vw'
                    ].join(', ')}
                    placeholder
                />
            </Link>
            <Appear>
                <>
                    {tagLink?.url && (<div className="banner-bundle-card__tag">
                        <SeriesLink link={tagLink} title={`${tagLink?.name}`} style={{display: 'inline-flex', width: 'fit-content', '--underline-offset': '0px'} as CSSProperties} />
                    </div>)}
                </>
                <div className="banner-bundle-card__title-desc" id={id}>
                    <div className="banner-bundle-card__title">{title}</div>
                    {description && <p className={cx('banner-bundle-card__description', (truncateDescription && `banner-bundle-card--truncate banner-bundle-card--truncate-${truncateDescription}-lines`))}>{description}</p>}
                </div>
            </Appear>
        </div>
    )
}
